import React from "react";
import Validators from "Common/Validators";
import {  Form, Checkbox ,Input, message, Col} from "antd";
import "../PHI/Forms/Forms.scss";
import CommonButton from "Components/CommonButton";
import api from "utils/api";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
import { withTranslation , Trans} from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import { withRouter } from "react-router-dom";
import SelectActivePlan, { InfoCardEdit } from "./SelectActivePlan";
import { GreenEditIcon } from "Common/ReactIcons";
import utils from "utils";
import Icons from "Common/Icons";

class SelectReason extends React.Component {
constructor(props){
    super(props)
    this.state={
        is_loading:true,
        selected_reasons:[],
        options:[],
        optionResponse:{},
        defaultSelected:[],
        comments:""
    }
    this.form = React.createRef();
}
 
getOptions=()=>{
  let TempDrop=[];
  let tempSelected=[];
  api.get_area_of_improvement().then(res => {
    let response = res.data ||{};
    if(res?.status == 200)
    {
      response.data.improvement_areas.map((option)=>{
        if(option.is_selected)
          {
            tempSelected.push(option.field_title);
          }
        let temp = {"label":<div>{option.field_title} {option?.field_subtitle && "("+option?.field_subtitle+")"}</div>,"value":option.field_title,"id":option.field_id}
        TempDrop.push(temp)
      })
      if(tempSelected.length==3)
        {
          TempDrop.map((options)=>{
            if(!tempSelected.includes(options.value))
              {
                return(options.disabled=true);
              }
          })
        }
        this.setState({options : TempDrop, is_loading:false,optionResponse:response.data,defaultSelected:tempSelected,comments:response.data.comments,selected_reasons:tempSelected})
        
      }
    else
    {
      message.error();
      this.setState({is_loading:false});
    }
  }).finally(() => {
    // this.setState({is_loading:false});
      })

}

componentDidMount=()=>{
  this.getOptions()
}

 handleSubmitReason=(values)=>{
  let temp = JSON.parse(JSON.stringify(this.state.optionResponse));
  let response = {};
  let data=[];
  temp.improvement_areas.map((options)=>{
    if(this.state.selected_reasons.includes(options.field_title))
      {
        data.push(options.field_id)
      }
  })
  response.improvement_areas=data;
  response.comments=values?.reason_words?.trim()||this.state?.comments?.trim() || "";
 this.props.updateReason(response)
 }

 selectedOptions=(options)=>{
  let tempOption = this.state.options;
    if(options.length<=this.state.optionResponse.max_selection_count|| this.state.selected_reasons.length<=this.state.optionResponse.max_selection_count)
    {
      this,this.setState({selected_reasons:options})
      if(options.length==this.state.optionResponse.max_selection_count)
      {
          tempOption.forEach((opt)=>{
            if(!options.includes(opt.value))
            {
              return opt.disabled=true;
            }
          })
      }
      else{
        tempOption.forEach((opt)=>{
          return opt.disabled=false;
        })
      }
    }
    return tempOption; 
 }
  handleSelectActivePlan(){        
  utils.Modal(true, { content: <SelectActivePlan onClick={(payload)=>{
    utils.Modal(false);
    this.props.setActivePlan(payload)
  }} care_plan_arr={this.props.care_plan_arr} activeCarePlan={this.props.activeCarePlan} doctorID={this.props.doctorID}/>, width: "480px" })            
}
    render(){
      const { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const activeCarePlan=this.props.activeCarePlan||null;
    const doctorSelectedData=this.props.doctorSelectedData||{};
    const doctor_card_render=doctorSelectedData?.clinician_first_name ||null;
    const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
        return(
         <> {this.state.is_loading?<Loader tgtLangST={tgtLangST}/>: 
         <div className="slct-res-wrapper">

            <Col className="slct-res-content">
              <div>
            <Form
               name={"reason-form"}
               onFinish={(values)=> this.handleSubmitReason(values)}
               ref={this.form}>
              <Form.Item  className="radio_button-form-item form-wrapper-container button-padding" 
                name={"reason"}>
                  {doctor_card_render&& <div className="slct-res-words" style={{marginBottom:"24px"}}>
              <div className="slct-res-words-title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SELECTED_CLINICIAN,{lng:tgtLangST})}</Trans></div>
              <div>
                <InfoCardEdit  title={`${doctorSelectedData.salutation} ${doctorSelectedData.clinician_first_name} ${doctorSelectedData.clinician_last_name}`}
        description={doctorSelectedData?.qualification||""} Icon={doctorSelectedData.profile_picture} onClick={()=>{this.props.history.push({
          pathname: "/logged-in-user/preferred-clinician"
      });}}/>
              </div>
            </div>}
                {(activeCarePlan &&doctor_card_render) && <div className="slct-res-words" style={{marginBottom:"24px"}}>
              <div className="slct-res-words-title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SELECTED_PLAN,{lng:tgtLangST})}</Trans></div>
              <div>
                <InfoCardEdit  title={activeCarePlan.plan_name}
        description={utils.sessionsCompletedText(activeCarePlan?.completed_sessions, activeCarePlan?.total_sessions)} Icon={Icons.plan_icon} onClick={()=>this.handleSelectActivePlan()} hide_edit={activeCarePlan?.hide_edit}/>
              </div>
            </div>}
            <div  className="slct-res-card" style={{marginBottom:"24px"}}>
             <div  className="title">
            <p><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.THREE_OPTIONS,{lng:tgtLangST})}</Trans> </p>
            </div>
           
            {/* <div   className="slct-rec-options radio_button-form-item form-wrapper-container button-padding"> */}
                      <Checkbox.Group   
                        defaultValue={this.state.defaultSelected}                          
                        className="slct-rec-options"          
                        onChange={(val) => this.selectedOptions(val) }
                        options={this.state.options}/>
            {/* </div> */}
           
            </div>
            </Form.Item>
             <Form.Item
              name={"reason_words"}
              rules={[
                Validators.checkStringDescriptionLength,
                Validators.checkValidComments,
              ]}>
            <div className="slct-res-words">
              <div className="slct-res-words-title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.TEEL_OWN_WORDS,{lng:tgtLangST})}</Trans></div>
              <Input.TextArea defaultValue={this.state?.comments} style={{height:"100px"}} placeholder={t(CONSTANTS.TYPE_HERE_DOT,{lng:tgtLang})} size={"6"} />
            </div>
            </Form.Item>
            </Form>
            </div>
            
            </Col>
        <div>
        <CommonButton  disabled={this.state.selected_reasons.length>0?false:true} style={{margin:"32px auto 12px auto"}} className="common-button-green" onClick={()=>this.form.current.submit()} label={t(CONSTANTS.NEXT_CAP,{lng:tgtLang})}/>

          </div>
        </div>}
        </>
        )
    }
}

export default withRouter(withTranslation()(SelectReason));